import { loading } from '@/common/loading'
import { getHugeType, queryTitleListAjax } from '@/api/baseMsg'
import { Toast } from "vant";
import previewPDF from "@/components/previewPDF/index";
import config from '@/config/index'
import axios from "axios";
export default {
  name: "examine",
  components:{
    previewPDF
  },
  data() {
    return {
      option: [],
      List: [],
      searchName: '',
      pdfParams:{
        showPdf: false,
        data: ''
      },
      loading1: false,
      finished1: false,
      classCode: '',
      classList: [],
      dropdownTitle: "", //下拉展示标题
      dropdownInput: "", //搜索筛选框
      inputTable: [], //新数组作为筛选存储数组
      showDrop: false, //展示drop标记
      incomePayData: {
          pageIndex: 1, //请求第几页
          pageSize: 99, //每页请求的数量
      },
      listTwo: [], //用于上拉加载时将数据合并
      total: 0, //总页数]
      loading: false,
      finished: false
    }
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    init() {
      loading(true);
      this.getTaskNameList()
    },
    // 获取分类
    getTaskNameList() {
      getHugeType().then(
        (res) => {
          res.data = res.data.map(item=> ({
            ...item,
            name: item.codeName,
            value: item.codeValue
          }))
          this.classList = res.data;
          this.inputTable = res.data;
          this.handQuery();
        }
      );
    },
    //上拉加载
    onLoad() {
        this.incomePayData.pageIndex++; //加载时页码递增
        queryTitleListAjax({
          specilWord: this.searchName ? this.searchName : '',
          hugeType: this.classCode ? this.classCode : '',
          ...this.incomePayData,
          queryField: 'fileName',
          queryType: 2
        }).then(res => {
            this.listTwo = res.data.data; //将接口返回赋值data定义的数组
            this.total = res.data.total
            this.listTwo.forEach(item => { //循环返回的数据并将数据添加到list中
                this.List.push(item)
            })
            // 加载状态结束 状态更新为false
            this.loading = false;
            if (this.List.length >= this.total) { //将返回数据长度与总条数进行比较控制加载不加载的状态
                this.finished = true;
            }
        })
    },
    handQuery() {
      loading(true);
      this.List = []
      const params = {
        specilWord: this.searchName ? this.searchName : '',
          hugeType: this.classCode ? this.classCode : '',
        ...this.incomePayData,
        queryField: 'fileName',
        queryType: 2
      }
      queryTitleListAjax(params).then(res=> {
        this.List = res.data.data
        this.total = res.data.total
        if (this.List.length >= this.total) { //将返回数据长度与总条数进行比较控制加载不加载的状态
            this.finished = true;
        }
        loading(false);
      })
      
    },
    handFill(item) {
      loading(true)
      preDownloadPdfFile({reportId: item.id}).then(res=> {
        if(res.code == 200) {
          axios({
              url: config.devProxy +
              `/knowledge/importKnowledgeManage/downloadPdfFile?id=${item.fileId}`, //接口地址
              method: "get",
              responseType: "blob",
            }).then((res) => {
              const blob = new Blob([res.data])
              this.pdfParams.data = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
              loading(false)
              this.pdfParams.showPdf = true
          }).catch((res)=> {
            loading(false)
            Toast.fail("文件出错!")
            return
          })
        }else {
            loading(false)
            Toast.fail(res.message)
        }
      })
      
    },
    onClickLeft () {
        this.$router.push('/');
    },
    onLoad1() {
      setTimeout(() => {
        // 加载状态结束
        this.loading1 = false;
        this.finished1 = true;
      }, 1000);
    },
    clearInput() {
      this.dropdownInput = ''
      this.classCode = ''
    },
    fuzzyQuery(keyWord) {
      //搜索筛选方法
      if (keyWord.length == 0) {
        this.inputTable = this.classList;
        return;
      }
      const arr = [];
      for (let i = 0; i < this.classList.length; i++) {
        if (this.classList[i].name.indexOf(keyWord) >= 0) {
          arr.push(this.classList[i]);
        }
      }
      this.inputTable = arr;
    },
    dropClick(code, name) {
      //选择下拉列表点击事件
      this.dropdownInput = name;
      this.showDrop = !this.showDrop;
      // this.$refs.drop.toggle();
      this.classCode = code;
      this.handQuery()
    },
    hideTabs() {
      //隐藏展示滚动tabs
      this.fuzzyQuery(this.dropdownInput);
      this.showDrop = true;
    },
    showTabs() {
      //展示滚动tabs
      this.showDrop = false;
    },

    timestampToDateFormat(timestamp) {
      timestamp = Number(timestamp)
      const dateObj = new Date(timestamp); // 创建Date对象
      console.log(dateObj)
      const year = String(dateObj.getFullYear()); // 获取年份
      const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // 获取月份，并补零
      const day = String(dateObj.getDate()).padStart(2, "0"); // 获取日期，并补零
    
      return year + "-" + month + "-" + day; // 返回转换后的日期格式
    },
    getpdfShow(data) {
      this.pdfParams.showPdf = data;
    },
    handRoute(item) {
      // 文件类似
      const arrTransExt = [
        ".doc",
        ".docx",
        ".wps",
        ".pdf",
        "doc",
        "docx",
        "wps",
        "pdf"
      ];
      if(arrTransExt.includes(item.suffix)) {
        loading(true)
        let url = `/knowledge/importKnowledgeManage/downloadPdfFile?id=${item.fileId}`
        axios({
          url: config.devProxy + url, //接口地址
          method: "get",
          responseType: "blob",
        }).then((res) => {
          const blob = new Blob([res.data])
          this.pdfParams.data = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
          this.pdfParams.showPdf = true
          loading(false)
        }).catch((res)=> {
          loading(false)
          Toast.fail("文件出错!")
          return
        })
      }else {
        this.exportDownLoad({
          url: '/knowledge/importKnowledgeManage/downloadPdfFile',
          id: item.fileId
        })
      }
       
    }
  }
} 